import { useGetMaintenanceStatus } from "~/queries/use-get-maintenance-status";
import { MaintenanceBanner } from "~served/ui-comps/components/maintenance-banner";

export const MaintenanceNotice = () => {
	const { data } = useGetMaintenanceStatus();
	return data?.enabled ? <MaintenanceBanner message={data.message} /> : null;
};
